import { CHALLENGE_11_BADGES_MILESTONE } from "../../challengeConstants";
const points = [
  {
    index: 0,
    top: "39",
    left: "11.5",
    subPoint: [
      { top: "39", left: "11.5" },
      { top: "39", left: "11.5" },
      { top: "39", left: "11.5" },
    ],
    type: "main",
    label: "amway",
    totalStep: 0,
  },
  {
    index: 1,
    top: '49',
    left: '25.5',
    subPoint: [
      { top: "48", left: "23" },
      { top: "51", left: "21" },
      { top: "54", left: "19" },
    ],
    type: "pin",
    totalStep: 500,
  },
  {
    index: 2,
    top: '59',
    left: '33.5',
    subPoint: [
      { top: "59.1", left: "30.7" },
      { top: "59", left: "28" },
      { top: "54", left: "27" },
    ],
    type: "pin",
    totalStep: 33000,
  },
  {
    index: 3,
    top: '58',
    left: '44',
    subPoint: [
      { top: "59.6", left: "41.7" },
      { top: "59.5", left: "39" },
      { top: "59.5", left: "36.4" },
    ],
    type: "pin",
    totalStep: 66000,
  },
  {
    index: 4,
    top: "40",
    left: "45",
    subPoint: [
      { top: "40", left: "45" },
      { top: "40", left: "45" },
      { top: "40", left: "45" },
    ],
    type: "main",
    label: CHALLENGE_11_BADGES_MILESTONE.badge1,
    totalStep: 100000,
    badgeY: 50,
    badgeX: -40,
    height: 170,
  },
  {
    index: 5,
    top: "25",
    left: "46.5",
    subPoint: [
      { top: "29", left: "47" },
      { top: "33", left: "48.5" },
      { top: "38", left: "48" },
    ],
    type: "pin",
    totalStep: 100500,
  },
  {
    index: 6,
    top: "10",
    left: "46.4",
    subPoint: [
      { top: "10", left: "46.4" },
      { top: "10", left: "46.4" },
      { top: "10", left: "46.4" },
    ],
    type: "main",
    label: CHALLENGE_11_BADGES_MILESTONE.badge2,
    totalStep: 200000,
    badgeY: 75,
    badgeX: 35,
    height: 200,
  },
  {
    index: 7,
    top: "22",
    left: "56.5",
    subPoint: [
      { top: "16.2", left: "56" },
      { top: "15.2", left: "53" },
      { top: "15.2", left: "50" },
    ],
    type: "pin",
    totalStep: 200500,
  },
  {
    index: 8,
    top: "31",
    left: "65.5",
    subPoint: [
      { top: "31.2", left: "62" },
      { top: "31.5", left: "58" },
      { top: "26", left: "56.5" },
    ],
    type: "pin",
    totalStep: 250000,
  },
  {
    index: 9,
    top: "12",
    left: "68.5",
    subPoint: [
      { top: "12", left: "68.5" },
      { top: "12", left: "68.5" },
      { top: "12", left: "68.5" },
    ],
    type: "main",
    label: CHALLENGE_11_BADGES_MILESTONE.badge3,
    totalStep: 300000,
    badgeY: 85,
    badgeX: -40,
    height: 180,
  },
  {
    index: 10,
    top: "24",
    left: "84",
    subPoint: [
      { top: "24", left: "80.5" },
      { top: "24", left: "77" },
      { top: "24", left: "73.5" },
    ],
    type: "pin",
    totalStep: 300500,
  },
  {
    index: 11,
    top: "37",
    left: "88",
    subPoint: [
      { top: "32", left: "88.5" },
      { top: "26", left: "88.5" },
      { top: "24", left: "85" },
    ],
    type: "pin",
    totalStep: 333000,
  },
  {
    index: 12,
    top: "49",
    left: "84.5",
    subPoint: [
      { top: "43", left: "84.5" },
      { top: "39", left: "85.5" },
      { top: "37", left: "88" },
    ],
    type: "pin",
    totalStep: 367000,
  },
  {
    index: 13,
    top: "50",
    left: "86.5",
    subPoint: [
      { top: "50", left: "86.5" },
      { top: "50", left: "86.5" },
      { top: "50", left: "86.5" },
    ],
    type: "main",
    label: CHALLENGE_11_BADGES_MILESTONE.badge4,
    totalStep: 400000,
    badgeY: 60,
    badgeX: 35,
    height: 170,
  },
  {
    index: 14,
    top: "52",
    left: "73.5",
    subPoint: [
      { top: "54.4", left: "76.5" },
      { top: "60", left: "77" },
      { top: "65", left: "79" },
    ],
    type: "pin",
    totalStep: 400500,
  },
  {
    index: 15,
    top: "37.2",
    left: "75",
    subPoint: [
      { top: "37.2", left: "76.5" },
      { top: "37.2", left: "76.5" },
      { top: "37.2", left: "76.5" },
    ],
    type: "main",
    label: CHALLENGE_11_BADGES_MILESTONE.badge5,
    totalStep: 500000,
    badgeY: 50,
    badgeX: 10,
    height: 150,
  },
  {
    index: 16,
    top: "49",
    left: "65",
    subPoint: [
      { top: "44", left: "65" },
      { top: "40", left: "67" },
      { top: "40", left: "70" },
    ],
    type: "pin",
    totalStep: 500500,
  },
  {
    index: 17,
    top: "76",
    left: "65",
    subPoint: [
      { top: "70", left: "65.5" },
      { top: "64", left: "64.5" },
      { top: "58", left: "65.2" },
    ],
    type: "pin",
    totalStep: 550000,
  },
  {
    index: 18,
    top: '57',
    left: '55',
    subPoint: [
      { top: "57", left: "55" },
      { top: "57", left: "55" },
      { top: "57", left: "55" },
    ],
    type: "main",
    label: CHALLENGE_11_BADGES_MILESTONE.badge6,
    totalStep: 600000,
    badgeY: 80,
    badgeX: -60,
    height: 200,
  },
];

export default points;
